import { render, staticRenderFns } from "./result-hover.vue?vue&type=template&id=f82727b4&scoped=true&"
import script from "./result-hover.vue?vue&type=script&lang=js&"
export * from "./result-hover.vue?vue&type=script&lang=js&"
import style0 from "./result-hover.vue?vue&type=style&index=0&id=f82727b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82727b4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f82727b4')) {
      api.createRecord('f82727b4', component.options)
    } else {
      api.reload('f82727b4', component.options)
    }
    module.hot.accept("./result-hover.vue?vue&type=template&id=f82727b4&scoped=true&", function () {
      api.rerender('f82727b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/helpers/result-hover.vue"
export default component.exports